import React, { useState } from 'react';
import Toast from '../../components/common/Toast';
import { useLanguage } from '../../helpers/language-context';
import { supabase } from '../../supabaseClient';
import { renderHTML } from '../../helpers/render-html';

const GetInTouchForm = () => {
  const { translations } = useLanguage();   
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.message) {
      setToast({ show: true, message: 'Please fill in all required fields.', type: 'error' });
      return;
    }

    setIsSubmitting(true);
    try {
      const { error } = await supabase
        .from('contact_messages')
        .insert([{
          name: formData.name,
          email: formData.email,
          company: formData.company,
          message: formData.message
        }]);

      if (error) throw error;

      setToast({ show: true, message: 'Message sent successfully!', type: 'success' });
      setFormData({
        name: '',
        email: '',
        company: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending message:', error);
      setToast({ show: true, message: 'Failed to send message. Please try again.', type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="get-in-touch-section">
        <Toast
          show={toast.show}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, show: false })}
        />
      <div className="w-full grid grid-cols-1 lg:grid-cols-2">
        {/* Left Column - Contact Info */}
        <div className="sub-section space-y-12 bg-gray-50 flex flex-col justify-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-[#28357B]">
            {translations.contact.getInTouch}
          </h1>
          
          <p dangerouslySetInnerHTML={renderHTML(translations.contact.getInTouchDesc)} />
        </div>

        {/* Right Column - Form */}
        <div className="sub-section">
          <div className="space-y-6">
            {/* Name Field */}
            <div>
              <label htmlFor="name" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                NAME <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-0 py-3 border-0 border-b-2 border-gray-200 focus:border-indigo-600 focus:ring-0 bg-transparent transition-colors duration-200 outline-none"
              />
            </div>

            {/* Email Field */}
            <div>
              <label htmlFor="email" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                {translations.contact.email} <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-0 py-3 border-0 border-b-2 border-gray-200 focus:border-indigo-600 focus:ring-0 bg-transparent transition-colors duration-200 outline-none"
              />
            </div>

            {/* Company Field */}
            <div>
              <label htmlFor="company" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                {translations.contact.company}
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full px-0 py-3 border-0 border-b-2 border-gray-200 focus:border-indigo-600 focus:ring-0 bg-transparent transition-colors duration-200 outline-none"
              />
            </div>

            {/* Message Field */}
            <div>
              <label htmlFor="message" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                {translations.contact.message} <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full px-0 py-3 border-0 border-b-2 border-gray-200 focus:border-indigo-600 focus:ring-0 bg-transparent transition-colors duration-200 outline-none resize-none"
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="pt-4">
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="bg-[#28357B] hover:bg-indigo-800 text-white font-semibold px-10 py-4 rounded-full transition-colors duration-200 disabled:opacity-50"
              >
                {isSubmitting ? 'Sending...' : translations.button.sendMessage}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GetInTouchForm;
